<template>
  <el-container class="home">
    <el-header v-show="isShow" class="home-header full-bg" :class="{'dark':skinType}">
      <Header @isNavCollapse="toggleNavsListener"></Header>
    </el-header>
    <el-container style="overflow:auto">
      <el-aside v-show="isShow" class="navs-container" width="auto" :class="{'dark':skinType}">
        <Navs :isCollapse="isNavCollapse"> </Navs>
      </el-aside>
      <el-main style="overflow:hidden" class="d-flex flex-column"
      :class="{'bg-dark':skinType}">
        <router-view class="none-height flex-grow-1"></router-view>
      </el-main>
    </el-container>
    <div class="Alarmlist" v-if="showPrise">
         <div class="xbutton" @click="Alarmnone()">X</div>
         <div class="tablestyle">
          <el-table
    :data="tablelist"
    height="18rem"
    :class="{ 'dark': skinType }"
    border
    header-cell-class-name="skinType?'':'bg-gray'"
    :cell-style="{'text-align':'center'}"
    header-row-style="font-size:'30px'"
    :header-cell-style="{background:'#2e4395'}"
    @row-click="GoworkOrderDetail"
    :row-class-name="(...nu)=>{return skinType?'dark text-white':''}"
  >
    <el-table-column prop="EquipmentName" label="告警设备" min-width="100" align="center">
    </el-table-column>
     <el-table-column prop="State" label="告警状态" width="80">
      <template slot-scope="scope">
        <div>{{ scope.row.State | filterStatus }}</div>
      </template>
    </el-table-column>
    <!-- <el-table-column
      prop="State"
      width="100"
      label="告警状态"
      align="center"
    ></el-table-column> -->
    <el-table-column prop="RuleClassName" label="告警类型" width="120" align="center">
    </el-table-column>

    <el-table-column
      prop="MarkTime"
      width="160"
      label="告警时间"
      align="center"
    >
    </el-table-column>
    <!-- <el-table-column label="大屏" width="60">
      <template slot-scope="scope" >
        <span  plain class="iconfont iconjinrushiyan cursor-pointer"
        @click="handleClick(scope.row)"></span>
      </template>
    </el-table-column> -->
  </el-table>
  </div>
       </div>
  </el-container>
</template>
<script>
import Navs from '@/components/home/navs/navs.vue';
import Header from '@/components/home/headers/header.vue';
import { getDataList, updatereadStatus, updatereadStatusbyids } from '@/api/personal-center/setting';
// import updatereadStatus from '@/api/alarmList/alarmList';
import { _BASE_Configuration } from '@/const/values.js';
export default {
  name: 'Home',
  components: {
    Navs,
    Header,
  },
  data() {
    return {
      // actiontime: 0, // 定时器
      tablelist: [],
      showPrise: false,
      isNavCollapse: false,
      isShow:_BASE_Configuration
    };
  },
  // created(){
      // window.location.href = '/Home/index'; 
  // },
  computed: {
    skinType() {
      return this.$store.getters.skinType;
    },
  },
  filters: {
    filterStatus(stateType) {
      let state = '';
      switch (stateType) {
        case 0:
          state = '未处理';
          break;
        case 1:
          state = '处理中';
          break;
        case 2:
          state = '已处理';
          break;
        case 3:
          state = '已忽略';
          break;
        default:
          break;
      }
      return state;
    },
  },
  mounted() {
    // this.actiontime = setInterval(() => {
    //   this.requestDataCount();
    // }, 6000);
  },
  beforeDestroy() {
    clearInterval(this.actiontime);
  },
  methods: {
    Alarmnone() {
      this.showPrise = false;
      let idstrs = '';
      for (let i = 0; i < this.tablelist.length; i += 1) {
        if (i === this.tablelist.length - 1) {
          idstrs += this.tablelist[i].TABID;
        } else {
          idstrs += `${this.tablelist[i].TABID},`;
        }
      }
      const params = {
        WRIDs: idstrs,
      };
      updatereadStatusbyids(params).then(() => {
      });
    },
    GoworkOrderDetail(rowindex) {
      const params = {
        WRID: rowindex.TABID,
      };
      updatereadStatus(params).then(() => {
      });
      this.$router.push({
        // path: 'realtime-monitoring/workorder-management',
        name: 'workorder-management',
        query: {
          id: rowindex.TABID,
        },
      });
    },
    toggleNavsListener(isNavCollapse) {
      this.isNavCollapse = isNavCollapse;
    },
    // 执行定时器接口，判断数据是否存在来展示或隐藏弹窗
    requestDataCount() {
      const that = this;
      getDataList().then((res) => {
        if (res.total > 0) {
          that.tablelist = res.list.List;
          that.showPrise = true;
        } else {
          that.showPrise = false;
        }
      }).catch(() => {
      });
    },
  },
};
</script>
<style lang="less" scoped>
.home-header{
  background-color: #409EFF;
}
.home-header.dark{
  background-color: #3344AA;
}
.Alarmlist {
  position: absolute;
  right: 0;
  bottom: 0;
  width: 600px;
  margin-right: 10px;
  height: 21rem;
  z-index: 9999;
}
.xbutton{
  /* margin-top: 5px; */
  /* margin-right: 5px; */
  width: 2%;
  float: right;
  cursor:pointer;
  position: relative;
  z-index: 99909;
  top: 10%;
  right: 2.5%;
}
.xbutton:hover{
color: red;
}
.tablestyle{
  width:98%;
  float:left;
  border-top:1px solid #4267c4;
  border-bottom:1px solid #4267c4;
  border-left:1px solid #4267c4;
  border-right:1px solid #4267c4;
  background-color: #223388;
}
/* 修改鼠标移入时的背景颜色，并没有起效 */
// /deep/ .el-table tbody tr:hover>td { background-color: red }

.tableHead{
    font-size: 30px;
}
</style>
